import xfetch from '@ms/fetch'
import cacheResponse from '@ms/fetch/cache'
import { controller } from '@ms/fetch/cancel'

/**
 * Fetches the global configuration from the backend and caches the response.
 *
 * @function
 * @returns {Promise<Object>} A promise that resolves to the global configuration data.
 */
export const fetchGlobalConfig = () => {
  const key = 'globalConfig'
  controller.abort(key)
  const signal = controller.create(key)
  return cacheResponse(
    key,
    xfetch('/basicParams/values/frontend', { signal }).then((data) => data.data)
  )
}

/**
 * 获取 android app 下载信息
 * @param  {String}   product  产品名 例: intl(国际版) ，不传则根据当前项目默认contryCode获取例如：尼日利亚:”ng”
 * @return {[type]}
 */
export const getAndroidInfo = async (product = '') => {
  return xfetch(`/common/config/versionInfo/android?product=${product}`)
}
